module.exports = __webpack_public_path__ + "img/4.85239fa3.png";